<script setup lang="ts">
import { onMounted, computed, ref, nextTick } from 'vue';
import { QForm, QInput, useDialogPluginComponent } from 'quasar';

defineEmits([...useDialogPluginComponent.emits]);
const props = defineProps<{
  fileName: string;
  fileId: string;
}>();

const { dialogRef: renameFileDialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent();
const renameFileDialogInputRef = ref<QInput | null>(null);
const localFileName = ref('');
const editableValue = ref('');
const isEditable = computed(() => localFileName.value === editableValue.value);

const formRef = ref<QForm | null>(null);

const selectInputText = () => {
  nextTick(() => {
    if (renameFileDialogInputRef.value) {
      renameFileDialogInputRef.value.select();
    }
  });
};

onMounted(() => {
  localFileName.value = props.fileName;
  editableValue.value = props.fileName;
});
</script>

<template>
  <q-dialog
    ref="renameFileDialogRef"
    persistent
    @hide="onDialogHide"
  >
    <q-card class="dialog-edit-file-name">
      <q-card-section class="q-px-lg q-pt-lg">
        <div class="row items-center justify-between">
          <div class="text-h6">
            Rename file
          </div>
          <q-btn
            flat
            round
            dense
            size="md"
            color="primary"
            icon="close"
            @click="onDialogHide"
          />
        </div>
      </q-card-section>

      <q-card-section class="q-px-lg">
        <q-form
          ref="formRef"
          @submit.prevent="onDialogOK({ editableValue, fileId:props.fileId })"
        >
          <q-input
            ref="renameFileDialogInputRef"
            v-model="editableValue"
            color="secondary"
            label="File Name"
            autofocus
            @keydown.stop
            @focus="selectInputText"
          />
          <div class="q-ml-md q-mt-lg flex justify-end">
            <q-btn
              v-close-popup
              flat
              color="primary"
              label="Cancel"
              no-caps
            />
            <q-btn
              flat
              color="secondary"
              label="Save"
              type="submit"
              no-caps
              :disabled="isEditable"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.dialog-edit-file-name {
  min-width: 450px;
}
</style>
